import { Navigate, useTypedParams } from '@sorare/routing';

import { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_MY_CARDS_CARDS_TYPE,
  ANY_SPORT_MY_CARDS_VAULT_TYPE,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { ANALYTICS_TAGS } from '@sorare/core/src/lib/events';

import { SealingEntryPoint } from '@sorare/marketplace/src/components/sealing/SealingEntryPoint';
import { myVaultFilters as footballMyVaultFilters } from '@sorare/marketplace/src/searchCards/football/cardFilters';
import { myVaultFilters as mlbMyVaultFilters } from '@sorare/marketplace/src/searchCards/mlb/cardFilters';

import { MyCardsSearch } from 'components/myCards/MyCardsSearch';

import type { PageParams } from './__generated__/routeParams';

const MyCardsVaultTypePage = () => {
  const { type } = useTypedParams<PageParams>();
  const { sport, generateSportContextPath } = useSportContext();

  if (type === Rarity.common) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_MY_CARDS_CARDS_TYPE, {
          params: { type: Rarity.common },
        })}
      />
    );
  }
  return (
    <MyCardsSearch
      sport={sport}
      analyticsTags={['Gallery', ANALYTICS_TAGS[sport]]}
      cardFilters={
        sport === Sport.BASEBALL ? mlbMyVaultFilters : footballMyVaultFilters
      }
      rarity={(type as Rarity) || Rarity.limited}
      PrependedItemComponent={({ total }) => (
        <SealingEntryPoint total={total} rarity={type as Rarity} />
      )}
      rarityPath={newRarity =>
        generateSportContextPath(ANY_SPORT_MY_CARDS_VAULT_TYPE, {
          params: {
            type: newRarity,
          },
          sport,
        })
      }
      sealed
    />
  );
};

export default MyCardsVaultTypePage;
